import { useLocation, Link, Navigate } from 'react-router-dom'
import { 
  CheckCircle, 
  BookOpen, 
  Receipt, 
  ArrowRight,
  Sparkles
} from 'lucide-react'

interface LocationState {
  orderNumber: string
  subscriptionId: number | null
  productName: string
}

export function SubscriptionSuccessPage() {
  const location = useLocation()
  const state = location.state as LocationState | null

  // state가 없으면 홈으로 리다이렉트
  if (!state?.orderNumber) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="max-w-2xl mx-auto py-16 px-4 text-center">
      {/* Success Animation */}
      <div className="relative mb-8">
        <div className="w-24 h-24 mx-auto bg-green-100 rounded-full flex items-center justify-center animate-bounce-slow">
          <CheckCircle className="w-14 h-14 text-green-600" />
        </div>
        <Sparkles className="w-8 h-8 text-yellow-400 absolute top-0 right-1/3 animate-pulse" />
        <Sparkles className="w-6 h-6 text-yellow-400 absolute bottom-4 left-1/3 animate-pulse delay-100" />
      </div>

      {/* Success Message */}
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
        구독이 완료되었습니다!
      </h1>
      <p className="text-lg text-gray-600 mb-8">
        {state.productName}에 대한 접근 권한이 활성화되었습니다.<br />
        지금 바로 학습을 시작해보세요!
      </p>

      {/* Order Info Card */}
      <div className="card p-6 mb-8 text-left">
        <h2 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <Receipt className="w-5 h-5 text-primary-600" />
          주문 정보
        </h2>
        <div className="space-y-3 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-500">주문번호</span>
            <span className="font-mono text-gray-900">{state.orderNumber}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">상품명</span>
            <span className="text-gray-900">{state.productName}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">구독 상태</span>
            <span className="text-green-600 font-medium">활성</span>
          </div>
        </div>
      </div>

      {/* CTA Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link
          to="/learn"
          className="btn-primary px-8 py-4 text-lg flex items-center justify-center gap-2"
        >
          <BookOpen className="w-5 h-5" />
          학습 시작하기
          <ArrowRight className="w-5 h-5" />
        </Link>
        <Link
          to="/"
          className="btn-secondary px-8 py-4 text-lg"
        >
          홈으로 돌아가기
        </Link>
      </div>

      {/* Help Text */}
      <p className="text-sm text-gray-500 mt-8">
        결제 관련 문의사항이 있으시면{' '}
        <a href="mailto:support@quebon.com" className="text-primary-600 hover:underline">
          support@quebon.com
        </a>
        으로 연락해주세요.
      </p>

      {/* Confetti-like Animation CSS */}
      <style>{`
        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
        .delay-100 {
          animation-delay: 100ms;
        }
      `}</style>
    </div>
  )
}





















